/**
 * @generated SignedSource<<0f40d8821b60249b8c52bcf5e8e0bed3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Fragments_AllAddressUseCodesDropdown",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "display",
      "storageKey": null
    }
  ],
  "type": "AddressUseCode",
  "abstractKey": null
};

node.hash = "300cbb16d0b1364de6bfb7f9ccab92bf";

export default node;
